import BeeInput from './input.vue'

BeeInput.install = (Vue) => {
  Vue.component(BeeInput.name, BeeInput)
}

export default BeeInput



// WEBPACK FOOTER //
// ./src/components/input/index.js